
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {
  currentUserModule,
  dataFieldsEditModule, instrumentModule,
  queryModule,
  studyDefinitionModule, studyPatientModule, visitModule
} from "@/store";
import {formatDateTime} from "@/auxillary/date-format";
import DataFieldCache from "../../../../models/data.field.cache";
import {translate, translateFilter} from "@/auxillary/translation";
import QueryCreateMenuItem from "@/components/query/menu/QueryCreateMenuItem.vue";
import {MdbsCore} from "@/api/tsclient";
import {deepCopy} from "@/auxillary";
import QueryCreateDialog from "@/components/query/dialogs/QueryCreateDialog.vue";
import QueryTypeDefinitionDto = MdbsCore.QueryTypeDefinitionDto;
import QueryShortDto = MdbsCore.QueryShortDto;
import IQueryTypeDefinitionDto = MdbsCore.IQueryTypeDefinitionDto;
import IQueryCreateDto = MdbsCore.IQueryCreateDto;
import DataFieldQueriesMenu from "@/components/query/menu/DataFieldQueriesMenu.vue";
import {canSeeQueries} from "@/components/query/QueryPermissions";
import {isParentFieldType} from "@/auxillary/datafield.cache.helpers";

@Component({
  name: 'DataFieldBar',
  methods: {isParentFieldType},
  components: {
    DataFieldQueriesMenu,
    OkDialog,
    QueryCreateMenuItem,
    QueryCreateDialog
  },
  filters: {
    translateFilter
  }
})
export default class DataFieldBar extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  get barColor() {
    //if (this.filteredQueries.some(query => query.stageState != QueryStage.CLOSED))
    //  return 'error';
    return this.field.hasChanges && this.isNoExceptionValueOrType(this.field) ? 'secondary' : '';
  }

  get field() {
    return this.dataField;
  }

  get fieldParentReferenceType() {
    return this.field.referenceType;
  }

  get canRevertInput() {
    return this.field.hasChanges && !this.field.isLocked && this.field.isEditable && !isParentFieldType(this.field.definitionType);
  }

  get canDeleteInput() {
    return this.field.hasValues && !this.field.isLocked && this.field.isEditable && !isParentFieldType(this.field.definitionType);
  }

  get fieldParentReferenceId() {
    if (this.fieldParentReferenceType == "PatientDefinition")
      return studyPatientModule.studyPatient.id;
    if (this.fieldParentReferenceType == "VisitDefinition")
      return visitModule.visit.id;
    if (this.fieldParentReferenceType == "InstrumentDefinition")
      return instrumentModule.instrument.id ?? ""
    return "";
  }

  get dataFields() {
    return dataFieldsEditModule.dataFields;
  }

  get validationMessages() {
    return this.field?.id != null
        ? dataFieldsEditModule.validationMessages.filter(m => m.dataFieldId == this.field.id)
        : [];
  }

  translateMessage(displayKey: string, parameters?: { [key: string]: string }) {
    const translation = translate(displayKey, undefined, parameters);
    return translation != displayKey
        ? translation
        : displayKey
  }

  get text() {
    if (this.isNoExceptionValueOrType(this.field) && this.field.hasChanges) {
      return "geändert";
    }
    if (this.field.isLocked) {
      return `gesperrt`;
    }
    if (this.field.changeDate) {
      return `gespeichert am ${formatDateTime(this.field.changeDate)}`;
    }
    return "";
  }

  isNoExceptionValueOrType(field: DataFieldCache): boolean {
    return field.values?.value != 'unprocessed' && field.definitionType != "DisplayValue";
  }

  toggleLockManually() {
    // TODO create endpoint to Manually Lock and Unlock Datafields
    if (!currentUserModule.hasRight("LockDataField"))
      return;

    if (this.field.isLockedManually) {
      dataFieldsEditModule.unlockManually({field: this.field})
    } else {
      dataFieldsEditModule.lockManually({field: this.field})
    }
  }

  resetValues() {
    dataFieldsEditModule.resetValues({field: this.field})
  }

  deleteValues() {
    dataFieldsEditModule.deleteValues({field: this.field})
  }

  // QUERIES
  showCreateQuery = false;
  createQueryDefinition: IQueryTypeDefinitionDto | null = null;

  get myVisibleQueryTypeDefinitions(): Array<QueryTypeDefinitionDto> {
    if (this.field.isNewField) return [];
    return studyDefinitionModule.myVisibleQueryTypeDefinitions;
  }

  get myCreatableQueryTypeDefinitions(): Array<QueryTypeDefinitionDto> {
    if (this.field.isNewField) return [];
    return studyDefinitionModule.myCreatableQueryTypeDefinitions;
  }

  get hasCreatableQueryDefinitions() {
    return canSeeQueries && this.myCreatableQueryTypeDefinitions.length > 0;
  }

  get queries(): Array<QueryShortDto> {
    return queryModule.queriesForFields(this.fieldParentReferenceType ?? "", this.dataField.id) ?? [];
  }

  get hasVisibleQueries() {
    return canSeeQueries && this.queries.length > 0;
  }

  handleCreateQuery(queryDefinition: IQueryTypeDefinitionDto) {
    this.createQueryDefinition = deepCopy(queryDefinition);
    this.showCreateQuery = true;
  }

  async handleSaveCreateQuery(queryCreate: IQueryCreateDto) {
    await queryModule.createQueryForField({
      referenceType: this.fieldParentReferenceType ?? "",
      referenceId: this.fieldParentReferenceId,
      createDto: queryCreate
    });

    this.showCreateQuery = false;
  }

}
